module.exports = __webpack_public_path__ + "img/mobile/BetBar-freespins/fs-spins-bg@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar-freespins/fs-spins-bg@3x.png
// module id = 183
// module chunks = 0